import { lazy } from 'react'
import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'
const AppVentaRegistro = Loadable(lazy(() => import('./view/VentaRegistro')))
const AppVentaGestion = Loadable(lazy(() => import('./view/VentaGestion')))

export const ventasOfflineRoutesMap = {
  registroOffline: {
    path: '/venta-offline/registro',
    name: 'Registro de Ventas Offline',
  },
  gestionOffline: {
    path: '/venta-offline/gestion',
    name: 'Gestión Ventas Offline',
  },
}

const ventaOfflineRoutes = [
  {
    path: ventasOfflineRoutesMap.registroOffline.path,
    element: <AppVentaRegistro />,
    auth: authRoles.admin,
  },
  {
    path: ventasOfflineRoutesMap.gestionOffline.path,
    element: <AppVentaGestion />,
    auth: authRoles.admin,
  },
]
export default ventaOfflineRoutes
